/// <reference types="vite-plugin-pwa/client" />

import { registerSW } from "virtual:pwa-register";

const swReg = registerSW({
  immediate: false,
  onNeedRefresh() {
    const toast = document.createElement("div");
    toast.setAttribute("data-sw-toast", "");
    toast.style.cssText =
      "position:fixed;left:50%;bottom:calc(env(safe-area-inset-bottom) + 16px);transform:translateX(-50%);z-index:1200;display:flex;align-items:center;gap:12px;padding:12px 16px;background:var(--bg-elevated,#fff);color:var(--text-primary,#000);border-radius:14px;box-shadow:0 12px 32px rgba(0,0,0,0.18);font:inherit;font-size:14px;";
    const label = document.createElement("span");
    label.textContent = "New version available";
    const reload = document.createElement("button");
    reload.textContent = "Reload";
    reload.style.cssText =
      "background:#007AFF;color:#fff;border:none;border-radius:8px;padding:8px 14px;font:inherit;font-weight:600;cursor:pointer;";
    reload.addEventListener("click", () => swReg(true));
    const dismiss = document.createElement("button");
    dismiss.textContent = "Later";
    dismiss.style.cssText =
      "background:transparent;color:#007AFF;border:none;font:inherit;font-weight:600;cursor:pointer;";
    dismiss.addEventListener("click", () => toast.remove());
    toast.appendChild(label);
    toast.appendChild(reload);
    toast.appendChild(dismiss);
    document.body.appendChild(toast);
  },
  onOfflineReady() {
    // silent
  },
});

export { swReg };